export default __webpack_public_path__ + "static/student-7810f8b463fe39cbe7b05739f919e740.jpg";